import React from 'react'
import { string } from 'prop-types'

function ProductPrice({ price = '' }) {
  if (!price) return null

  return (
    <div className="listed-product__price u-text-center">
      {price}
    </div>
  )
}

ProductPrice.propTypes = {
  price: string,
}

export default ProductPrice
